/*
# Subview with action buttons - history, unlink, delete, next/prev, enter
*/

var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['backbone', 'app-common/component/loader', 'app-common/component/popover', 'common/component/je-history', 'template/document-entry/delete-conflict.htm', 'template/document-entry/unlink-preview.htm', 'template/document-entry/clear-unlink.htm', 'template/document-entry/delete.htm', 'template/document-entry/actions.htm', 'template/je-history-simple.htm'], function(Backbone, loader, Popover, jeHistory, deleteConflictTemplate, unlinkPreviewTemplate, clearUnlinkTemplate, deleteTemplate, actionsTemplate, jeHistoryTemplate) {
  var ActionsView;
  return ActionsView = (function(_super) {

    __extends(ActionsView, _super);

    function ActionsView() {
      ActionsView.__super__.constructor.apply(this, arguments);
    }

    ActionsView.prototype.className = 'document-actions-wrapper';

    ActionsView.prototype.template = actionsTemplate;

    ActionsView.prototype.noHistoryMessage = '<div class="no-history">There is no history of changes for this transaction.</div>';

    ActionsView.prototype.events = {
      'click #document-history:not(.disabled)': 'showJeHistory',
      'click #document-delete:not(.disabled)': 'delete',
      'click #document-unlink:not(.disabled)': 'unlink',
      'click #document-clear-unlink:not(.disabled)': 'clearUnlink'
    };

    ActionsView.prototype.initialize = function(options) {
      this.navigation = options.navigation;
      this.navigationEventMode = options.navigationEventMode;
      this.model.on('change:id change:canApplyUnlink change:hasUnlinkHistory', this.updateActions, this);
      return this.render();
    };

    ActionsView.prototype.render = function() {
      return this.$el.html(_.template(this.template, this.model.toJSON()));
    };

    ActionsView.prototype.remove = function() {
      ActionsView.__super__.remove.apply(this, arguments);
      return $(document).off('keydown.actions');
    };

    ActionsView.prototype.enableActions = function(actions) {
      var action, _i, _len, _results,
        _this = this;
      this.$el.find('.document-action').addClass('disabled');
      $(document).off('keydown.actions');
      _results = [];
      for (_i = 0, _len = actions.length; _i < _len; _i++) {
        action = actions[_i];
        this.$el.find("#document-" + action).removeClass('disabled');
        switch (action) {
          case 'history':
            _results.push($(document).on('keydown.actions', null, 'ctrl+h', function() {
              return _this.showJeHistory();
            }));
            break;
          case 'unlink':
            _results.push($(document).on('keydown.actions', null, 'ctrl+u', function() {
              return _this.unlink();
            }));
            break;
          case 'clear-unlink':
            _results.push($(document).on('keydown.actions', null, 'ctrl+shift+u', function() {
              return _this.clearUnlink();
            }));
            break;
          case 'delete':
            _results.push($(document).on('keydown.actions', null, 'ctrl+shift+backspace', function() {
              return _this["delete"]();
            }));
            break;
          default:
            _results.push(void 0);
        }
      }
      return _results;
    };

    ActionsView.prototype.updateActions = function() {
      var actions;
      if (this.model.isNew()) {
        this.enableActions([]);
        return;
      }
      actions = ['history', 'delete'];
      if (this.model.get('canApplyUnlink')) {
        actions.push('unlink');
      }
      if (this.model.get('hasUnlinkHistory')) {
        actions.push('clear-unlink');
      }
      return this.enableActions(actions);
    };

    ActionsView.prototype.showJeHistory = function(e) {
      var popover,
        _this = this;
      popover = new Popover($('#document-history'), 'top');
      return popover.action(e, function() {
        loader.init();
        return jeHistory.init(_this.model.get('id'), jeHistoryTemplate, true, function(content) {
          var entries;
          loader.hide();
          entries = $(content).find('.change-log-entry').length;
          if (entries === 0) {
            content = _this.noHistoryMessage;
          }
          popover.build(content);
          return popover.show();
        });
      });
    };

    ActionsView.prototype["delete"] = function(e) {
      var button, popover,
        _this = this;
      button = this.$el.find('#document-delete');
      popover = new Popover(button, 'top', {
        alignToRight: true,
        alignDiff: -23
      });
      return popover.action(e, function() {
        var conflictedLedger, message;
        conflictedLedger = _this.model.canDeleteCauseConflict();
        if (conflictedLedger) {
          message = deleteConflictTemplate;
          message = $("<div>" + message + "</div>").find('.conflicted-ledger').html(conflictedLedger.name).end().html();
        } else {
          message = deleteTemplate;
        }
        popover.build(message);
        popover.show();
        button.find('.delete-action').on('click', function() {
          var promise;
          loader.init();
          promise = _this.model.destroy();
          promise.fail(function() {
            return loader.hide();
          });
          return promise.done(function() {
            return _this.markInboxEventAsDone(function() {
              popover.hide();
              loader.hide();
              return _this.next(function() {
                return _this.exit();
              });
            });
          });
        });
        button.find('.cancel-action').on('click', function() {
          return popover.hide();
        });
        return button.find('.delete-action').focus();
      });
    };

    ActionsView.prototype.unlink = function(e) {
      var button, popover,
        _this = this;
      button = this.$el.find('#document-unlink');
      popover = new Popover(button, 'top');
      return popover.action(e, function() {
        var promise;
        loader.init();
        promise = _this.model.previewUnlink();
        promise.fail(function() {
          return loader.hide();
        });
        return promise.done(function(preview) {
          var content;
          loader.hide();
          content = _.template(unlinkPreviewTemplate, preview);
          popover.build(content);
          popover.show();
          button.find('.unlink-action').on('click', function() {
            loader.init();
            promise = _this.model.unlink();
            promise.fail(function() {
              return loader.hide();
            });
            return promise.done(function() {
              return _this.markInboxEventAsDone(function() {
                popover.hide();
                loader.hide();
                return _this.refreshDocument();
              });
            });
          });
          button.find('.cancel-action').on('click', function() {
            return popover.hide();
          });
          return button.find('.unlink-action').focus();
        });
      });
    };

    ActionsView.prototype.clearUnlink = function(e) {
      var button, popover,
        _this = this;
      button = this.$el.find('#document-clear-unlink');
      popover = new Popover(button, 'top');
      return popover.action(e, function() {
        popover.build(clearUnlinkTemplate);
        popover.show();
        button.find('.clear-unlink-action').on('click', function() {
          var promise;
          loader.init();
          promise = _this.model.clearUnlinkHistory();
          promise.fail = function() {
            return loader.hide();
          };
          return promise.done(function() {
            return _this.markInboxEventAsDone(function() {
              popover.hide();
              loader.hide();
              return _this.refreshDocument();
            });
          });
        });
        button.find('.cancel-action').on('click', function() {
          return popover.hide();
        });
        return button.find('.clear-unlink-action').focus();
      });
    };

    ActionsView.prototype.refreshDocument = function() {
      var promise,
        _this = this;
      loader.init();
      promise = this.model.fetch();
      return promise.always(function() {
        return loader.hide();
      });
    };

    return ActionsView;

  })(Backbone.View);
});
